import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderTwoComponent } from './loader-two.component';
import { TranslationModule } from 'src/app/i18n/translation.module';
import { LottieLoaderModule } from "../lottie-loader/lottie-loader.module";

@NgModule({
  declarations: [
    LoaderTwoComponent
  ],
  imports: [
    CommonModule,
    TranslationModule,
    LottieLoaderModule
],
  exports: [LoaderTwoComponent]
})
export class LoaderTwoModule { }
